// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__T_8Xe","topBottomGutter":"Layout_topBottomGutter__1iOH-"};